import { STREAMING_CONTENT_MUTED_CLASS } from '@/components/overlay/overlay-shimmer-text';

/** Wrapper-level fallback; the ProseMirror attr hook is the primary wire. */
export const STREAMING_PROSEMIRROR_MUTED_CLASS = STREAMING_CONTENT_MUTED_CLASS;
